export default __webpack_public_path__ + "static/06.06-f5c8eec1b4b122f0464432218cb82d03.png";